import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Determine environment based on hostname
const isDev = window.location.hostname === 'localhost' || 
              window.location.hostname.includes('127.0.0.1');

// Dev and Prod Firebase configurations
const devConfig = {
  apiKey: "AIzaSyC_LOdzTtdQXB9a2XPQydQ1Hmv33q8jpv4",
  authDomain: "visiongames-4eccf.firebaseapp.com",
  projectId: "visiongames-4eccf",
  storageBucket: "visiongames-4eccf.firebasestorage.app",
  messagingSenderId: "360788182586",
  appId: "1:360788182586:web:8ee77ed643d6e880e21703"
};

const prodConfig = {
  apiKey: "AIzaSyDIy58NFsoZ-KzzPyXN0ydD3Kj2-9wt16M",
  authDomain: "visiongames-fadd1.firebaseapp.com",
  projectId: "visiongames-fadd1",
  storageBucket: "visiongames-fadd1.firebasestorage.app",
  messagingSenderId: "325323920448",
  appId: "1:325323920448:web:e22ade7e673fc42a663ba5"
};

// Select config based on environment
const firebaseConfig = isDev ? devConfig : prodConfig;

// Optional: Log which environment is being used (remove in production if desired)
console.log(`Firebase initialized in ${isDev ? 'DEVELOPMENT' : 'PRODUCTION'} mode`);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;